import React from 'react';
import '../ListadoScroll.css';

/**
 * Layout de listado con scroll solo en el cuerpo de la tabla.
 * Header, bloques fijos, filtros y toolbar permanecen visibles.
 */
export function ListadoScrollLayout({
  className = '',
  scroll = true,
  header,
  fixedTop,
  filters,
  toolbar,
  panelClassName = '',
  panelExtra,
  refreshing = false,
  children,
  footer,
}) {
  const rootClass = [
    'pagina-listado',
    scroll ? 'pagina-listado--scroll' : '',
    className,
  ].filter(Boolean).join(' ');

  const tablaAreaClass = [
    'listado-tabla-area',
    'clientes-listado-tabla-area',
    refreshing ? 'listado-tabla-area--refreshing clientes-listado-tabla-area--refreshing' : '',
  ].filter(Boolean).join(' ');

  const hasPanel = filters || toolbar || children || panelExtra;

  return (
    <div className={rootClass}>
      {header}
      {fixedTop ? <div className="pagina-listado-fijo">{fixedTop}</div> : null}
      {hasPanel ? (
        <div className={`listado-panel clientes-listado listado-controles ${panelClassName}`.trim()}>
          {filters}
          {toolbar}
          {panelExtra}
          {children ? (
            <div className="listado-panel-cuerpo clientes-listado-cuerpo">
              <div className={tablaAreaClass}>
                <div className="table-container">
                  {children}
                </div>
                {refreshing ? (
                  <div className="listado-refresh-overlay clientes-listado-refresh-overlay" role="status" aria-live="polite">
                    <span className="listado-refresh-spinner clientes-listado-refresh-spinner" aria-hidden="true" />
                    <span className="listado-refresh-label clientes-listado-refresh-label">Actualizando…</span>
                  </div>
                ) : null}
              </div>
            </div>
          ) : null}
        </div>
      ) : null}
      {footer}
    </div>
  );
}

export default ListadoScrollLayout;
